import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  makeRequestedAtStr,
  serviceTypeNamesMap,
  timezoneMap,
} from '@open-tender/utils'
import {
  openModal,
  selectCheckout,
  selectOrder,
  selectQuote,
  useAppDispatch,
  useAppSelector,
} from '@open-tender/cloud'
import { ButtonLink, Loading } from 'components'
import CheckoutSection from './CheckoutSection'
import CheckoutSectionFootnote from './CheckoutSectionFootnote'
import CheckoutSectionTitle from './CheckoutSectionTitle'

const CheckoutPickup = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { orderType, requestedAt, revenueCenter, serviceType, prepType } =
    useAppSelector(selectOrder)
  const quote = useAppSelector(selectQuote)
  const { loading, submitting } = useAppSelector(selectCheckout)
  // The requestedAt the current check was validated against. After the
  // customer picks a new time, the check on screen is stale until validate
  // returns, so show a loader instead of the time until it settles.
  // Only settle when a pending validation finishes: requestedAt changes while
  // loading is still idle, and settling then would hide the loader.
  const [settledRequestedAt, setSettledRequestedAt] = useState(requestedAt)
  const prevLoading = useRef(loading)
  useEffect(() => {
    if (prevLoading.current === 'pending' && loading !== 'pending') {
      setSettledRequestedAt(requestedAt)
    }
    prevLoading.current = loading
  }, [loading, requestedAt])
  const isUpdatingTime =
    loading === 'pending' && !submitting && requestedAt !== settledRequestedAt
  const isCateringQuote = quote.order?.order_type === 'CATERING'
  const isMenuEditable = !isCateringQuote
  if (!revenueCenter || !serviceType) return null
  const { name, address, timezone, first_times } = revenueCenter
  const firstTime = first_times ? first_times[serviceType] : null
  const tz = timezoneMap[timezone]
  const requestedTime = tz ? makeRequestedAtStr(requestedAt, tz, true) : null
  const isAsap = requestedTime === 'ASAP' && serviceType === 'PICKUP'
  const requestedTimeStr = isAsap ? 'Now' : requestedTime
  const waitTime = isAsap ? firstTime?.wait_minutes || null : null
  let serviceTypeName = serviceTypeNamesMap[serviceType]
  serviceTypeName = prepType === 'TAKE_OUT' ? 'Take Out' : serviceTypeName

  const changeLocation = () => {
    navigate('/locations')
  }

  const adjustTime = () => {
    const args = {
      focusFirst: true,
      skipClose: true,
      revenueCenter,
      serviceType,
      orderType,
      requestedAt,
    }
    dispatch(openModal({ type: 'requestedAt', args }))
  }

  return (
    <CheckoutSection title="Location & Time">
      <CheckoutSectionTitle>{name}</CheckoutSectionTitle>
      <p>{address?.street}</p>
      {isUpdatingTime ? (
        <Loading text="Updating time..." style={{ textAlign: 'left' }} />
      ) : (
        <p>
          {serviceTypeName} Time: {requestedTimeStr}
          {waitTime && <span> (about {waitTime} mins)</span>}
        </p>
      )}
      <CheckoutSectionFootnote>
        {isMenuEditable && (
          <p>
            <ButtonLink onClick={changeLocation}>Change location</ButtonLink> or{' '}
            <ButtonLink onClick={adjustTime}>
              adjust {serviceTypeName?.toLowerCase()} time
            </ButtonLink>
          </p>
        )}
      </CheckoutSectionFootnote>
    </CheckoutSection>
  )
}

export default CheckoutPickup
